import React, { Fragment } from 'react';

import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';
import getConfig from '../../../../../../util/config';
import { SHUTTERBUG_TRIAL_DAYS_FALLBACK } from '../../../../../temp/views/onboarding/PhotoSearchUpsell/helpers';

const WebGalleryUpsellBannerFWGOnlyContent = () => {
  const config = getConfig();

  return (
    <Fragment>
      <img
        className="web-gallery-upsell-content-img"
        src={getAsset('/waldo_phone_cropped.png')}
        alt=""
      />

      <div className="web-gallery-upsell-content-copy">
        <h4>Share photos with friends and family all year long!</h4>
        <p>Get a Plus subscription today.</p>
      </div>

      <div className="web-gallery-upsell-content-actions">
        <Button
          btnSize="sm"
          id="btn_fwg_upsell_sb_trial"
          href={`${config.marcomUrl}/personal-plans/?utm_source=btn_fwg_upsell_sb_trial`}
          target="_blank"
        >
          {SHUTTERBUG_TRIAL_DAYS_FALLBACK} Day Free Trial
        </Button>
        <Button
          btnSize="sm"
          id="btn_fwg_upsell_sb_learn_more"
          href={`${config.marcomUrl}/products/shutterbug/?utm_source=btn_fwg_upsell_sb_learn_more`}
          target="_blank"
        >
          Learn More
        </Button>
      </div>
    </Fragment>
  );
};

export default WebGalleryUpsellBannerFWGOnlyContent;
